<div class="content">
    <consent [content]="content$()"></consent>
    <div #actions class="actions">
        <button cButton color="primary" (click)="onAccept()">Accept</button>
        <button cButton color="secondary" (click)="onDecline()">Decline</button>
    </div>
</div>